//importing assets

export const PersonCards = ({ list }) => {
  return (
    <div className="person-card--grid">
      {list.map((item, key) => (
        <PersonCard data={item} />
      ))}
    </div>
  );
};

export const PersonCard = ({ data }) => {
  return (
    <div className="person-card">
      <div className="person-card__img-box">
        <img src={data.img} alt="doctor" className="person-card__img" />
      </div>
      <h3 className="text--black poppins">{data.name}</h3>
      <p className="text--gray poppins">{data.desc}</p>
      <div className="person-card__social flex-between  ">
        <div className="pointer">
          <Insta />
        </div>
        <div className="pointer">
          {" "}
          <Facebook />
        </div>
        <div className="pointer">
          {" "}
          <Twitter />
        </div>
      </div>
    </div>
  );
};
const Insta = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6.5625"
        y="6.5625"
        width="16.875"
        height="16.875"
        rx="3.5"
        stroke="#246BFD"
        stroke-width="1.5"
      />
      <path
        d="M18.7479 14.876C18.7642 15.3682 18.6834 15.8588 18.5101 16.3197C18.3368 16.7807 18.0744 17.203 17.7379 17.5625C17.4014 17.9221 16.9973 18.2118 16.5488 18.4152C16.1003 18.6186 15.6162 18.7317 15.124 18.7479C14.6318 18.7642 14.1412 18.6834 13.6803 18.5101C13.2193 18.3368 12.797 18.0744 12.4375 17.7379C12.0779 17.4014 11.7882 16.9973 11.5848 16.5488C11.3814 16.1003 11.2683 15.6162 11.2521 15.124C11.2358 14.6318 11.3166 14.1412 11.4899 13.6803C11.6632 13.2193 11.9256 12.797 12.2621 12.4375C12.5986 12.0779 13.0027 11.7882 13.4512 11.5848C13.8997 11.3814 14.3838 11.2683 14.876 11.2521C15.3682 11.2358 15.8588 11.3166 16.3197 11.4899C16.7807 11.6632 17.203 11.9256 17.5625 12.2621C17.9221 12.5986 18.2118 13.0027 18.4152 13.4512C18.6186 13.8997 18.7317 14.3838 18.7479 14.876Z"
        stroke="#246BFD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.675 10.3125H19.6875"
        stroke="#246BFD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const Facebook = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="9.0625" stroke="#246BFD" stroke-width="1.5" />
      <path
        d="M17.8125 11.25H16.875C16.5877 11.25 16.3033 11.3066 16.0379 11.4165C15.7725 11.5264 15.5313 11.6876 15.3282 11.8907C15.1251 12.0938 14.9639 12.335 14.854 12.6004C14.7441 12.8658 14.6875 13.1502 14.6875 13.4375V24.0625M12.1875 16.875H17.8125"
        stroke="#246BFD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const Twitter = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.3828 7.47944C24.2456 7.33719 24.0334 7.29662 23.8529 7.37963L23.7765 7.41461C23.7116 7.44446 23.6468 7.47431 23.5815 7.5037C23.7713 7.20101 23.922 6.87733 24.026 6.54246C24.0838 6.35776 24.0208 6.15581 23.8679 6.03642C23.7149 5.91702 23.5041 5.90443 23.3385 6.00563C22.6049 6.45151 21.9118 6.72948 21.1576 6.87966L20.792 6.94169C21.7742 7.6632 22.415 8.82313 22.415 10.1356C22.415 10.1948 22.4122 10.2568 22.4108 10.317L22.4803 10.261C23.9378 9.04653 24.4434 8.05404 24.4644 8.01253C24.553 7.83484 24.5204 7.62123 24.3828 7.47944Z"
        fill="#246BFD"
      />
      <path
        d="M18.4509 6.17163C16.2616 6.17163 14.4865 7.94673 14.4865 10.136V10.8356C8.80022 10.5306 7.25738 6.63803 7.25738 6.63803C7.25738 6.63803 6.55779 7.57082 6.55779 8.97C6.55779 11.302 8.42337 12.2348 8.42337 12.2348C7.02419 12.2348 6.0914 11.7684 6.0914 11.7684C6.0914 11.7684 6.32459 14.3335 9.35616 15.4995L7.49058 15.9659C7.49058 15.9659 8.42337 17.5983 11.2217 18.2979C11.2217 18.2979 9.58936 19.6971 5.625 19.6971C5.625 19.6971 7.25738 21.5627 11.6881 21.5627C19.3837 21.5627 22.4152 14.3335 22.4152 10.136C22.4152 7.94673 20.6401 6.17163 18.4509 6.17163Z"
        stroke="#246BFD"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </svg>
  );
};
